export default __webpack_public_path__ + "static/media/stand against rape.7c925bd3.jpg";